import { forwardRef, type SelectHTMLAttributes } from 'react';
import { cn } from '@lib/utils/cn';

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  error?: boolean;
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, error, children, ...rest }, ref) => (
    <select
      ref={ref}
      className={cn(
        'flex h-9 w-full rounded-md border bg-surface px-3 text-sm',
        'focus:outline-none focus:ring-2 focus:ring-brand focus:border-transparent',
        'disabled:cursor-not-allowed disabled:opacity-60',
        error ? 'border-danger focus:ring-danger' : 'border-border',
        className,
      )}
      {...rest}
    >
      {children}
    </select>
  ),
);
Select.displayName = 'Select';
